<template>
    <div>
        <vs-alert v-if="onError" class="h-full mb-5" color="danger">
            <span>{{ errorMsg }}</span>
        </vs-alert>

        <div class="vx-row">
            <div class="vx-col w-full my-4">
                <h6>Ingresa la información:</h6>
            </div>
        </div>

        <div class="vx-row">
            <div class="vx-col w-full">
                <label class="vs-input--label">Grupo de producto</label>
                <v-select
                    label="text"
                    class="vs-custom w-full mb-5"
                    v-model.lazy="productGroupId"
                    :options="getProductGroupsList"
                    :reduce="text => text.value"
                    :clearable="false"
                    :searchable="true"
                    placeholder="Seleccione una opción" >
                    <div slot="no-options">No hay coincidencias</div> 
                </v-select>
            </div>
        </div>
        <div class="vx-row">
            <div class="vx-col w-full">
                <label class="vs-input--label">Entidad certificadora</label>
                <v-select
                    label="text"
                    class="vs-custom w-full mb-5"
                    v-model.lazy="certifyingEntityId"
                    :options="getCertifyingEntitiesList"
                    :reduce="text => text.value"
                    :clearable="false"
                    :searchable="true"
                    placeholder="Seleccione una opción" >
                    <div slot="no-options">No hay coincidencias</div> 
                </v-select>
            </div>
        </div>
        <div class="vx-row">
            <div class="vx-col w-full">
                <vs-input
                class="w-full mb-4" 
                label="Nombre de la certificación"
                placeholder="Requerido"
                data-vv-name="certification"
                v-model.lazy="name" />
            </div>
        </div>
        <document-upload
            :key="currentItem"
            :f="logoDocumentField"
            :doc="logoDocument"
            :target_id="currentItem.id"
            :inputClassExtraLarge="true"
            :evaluator="getLogoDocumentData"
            :editableByBackoffice="true"
            :automatic="true" 
            :isGeneralDoc="true" />

        <div class="vx-row">
            <div class="vx-col w-full">
                <vs-button @click="handleSave" :disabled="isSaveButtonDisabled" color="success" class="mr-5 mt-2">Guardar</vs-button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'EditCertificationModal',
    props: {
        itemsList: { type: Array, required: true },
        productGroupsList: { type: Array, required: true },
        certifyingEntitiesList: { type: Array, required: true },
        currentItem: { required: true },
        logoDocument: { required: true }
    },
    data() {
        return {
            productGroupId: null,
            certifyingEntityId: null,
            name: null,
            onError: false,
            errorMsg: null,
            // Nota: si cambias doc_assoc.table/assoc_key aquí, también debe actualizarse
            // ALLOWED_ASSOC_TABLE_KEYS en DocumentManagerController.php (backend),
            // o la asociación será rechazada con HTTP 400.
            logoDocumentField: {
				doc_id: 172,
				field_name: 'Logo de certificación',
				extras: JSON.stringify({
					doc_assoc: {
						table: 'certifications',
						assoc_key: 'id',
						condition: 'getLogoCondition'
					}
				})
			}
        };
    },
    computed: {
        isSaveButtonDisabled() {
            return (
                (this.name == null || !this.name.length) || 
                this.productGroupId == null ||
                this.certifyingEntityId == null
            );
        },
        getProductGroupsList() {
            return this.productGroupsList.map((productGroup) => ({ value: productGroup.id, text: productGroup.name }));
        },
        getCertifyingEntitiesList() {
            return this.certifyingEntitiesList.map((certifyingEntity) => ({ value: certifyingEntity.id, text: certifyingEntity.name }));
        }
    },
    methods: {
        async handleSave() {
            this.onError = false;

            if(this.name != this.currentItem.name && this.isItemDuplicated(this.name)) {
                this.onError = true;
                this.errorMsg = "Ya existe una certificación con el nombre " + this.name;
                this.showLoading(false);
                return;
            }

            this.showLoading(true);
            try {
                const {data} = await axios.put(`api/v1/certification/${this.currentItem.id}`, {
                    productGroupId: this.productGroupId,
                    certifyingEntityId: this.certifyingEntityId,
                    name: this.name
                });
                if(!data.success) {
                    this.onError = true;
                    this.errorMsg = data.message;
                    this.showLoading(false);
                    return;
                }
                this.productGroupId = null;
                this.certifyingEntityId = null;
                this.name = null;
                this.$emit('on-save', data.message);
            } 
            catch (error) {
                console.log(error);
            }
        },
        isItemDuplicated(newItem) {
            const newItemName = newItem.toLowerCase().trim();

            for (const {name} of this.itemsList) {
                const existingItemName = name.toLowerCase().trim();
                if(existingItemName == newItemName)
                    return true;
            }
        },
        setValues(item) {
            this.productGroupId = item.product_group.id;
            this.certifyingEntityId = item.certifying_entity.id;
            this.name = item.name;
        },
        getLogoDocumentData(condition) {
			if(condition != null && condition in this)
				return this[condition]();
		},
        getLogoSource() {
			return this.currentItem?.id;
		},
		getLogoCondition() {
			return true;
		},
    }
}
</script>